/**
 * Typed Redux Hooks
 *
 * Use these hooks instead of plain `useDispatch` and `useSelector`
 * to get proper TypeScript typing throughout the app.
 *
 * @see .github/copilot-instructions.md#state-management
 */

import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import type { RootState, AppDispatch } from './store';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
